import { render, staticRenderFns } from "./planDetailDc.vue?vue&type=template&id=538c76a0&scoped=true"
import script from "./planDetailDc.vue?vue&type=script&lang=js"
export * from "./planDetailDc.vue?vue&type=script&lang=js"
import style0 from "./planDetailDc.vue?vue&type=style&index=0&id=538c76a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538c76a0",
  null
  
)

export default component.exports